import React, { useState } from "react";
import styles from "./css/UploadAndViewFile.module.css";
import { FilesTypes } from "@/types";
import { ModelView } from "../files/ModelView";
import { FullScreenIcon } from "@/icons/FullScreenIcon";
import { FullScreenModal } from "../modal/FullScreenModal";

export const UploadAndViewFiile: React.FC<{
    file?: File | undefined | null;
    type: FilesTypes;
    fileUrl?: string;
}> = ({ file, type, fileUrl }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const renderContent = () => (
        <>
            {type === "3dmodel" && file && <ModelView file={file as File} />}
            {type === "3dmodel" && fileUrl && <ModelView fileUrl={fileUrl as string} />}
        </>
    );

    return (
        <>
            <div className={styles.container}>
                <div className={styles.content}>
                    {renderContent()}
                    <div className={styles.fullScreenIcon} onClick={() => setIsModalOpen(true)}>
                        <FullScreenIcon />
                    </div>
                </div>
            </div>

            <FullScreenModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                {renderContent()}
            </FullScreenModal>
        </>
    );
};